window.integrationsNS = {

    integrate: function (type, data) {

        var url = null;
        var success_message = null;
        var error_message =  GlobalTranslations['APP_LABEL.INTEGRATIONS.APPOINTMENT.ERROR'];
        var params = null;

        switch (type){
            case globalConstants.APPOINTMENT_INTEGRATION:
                url = "/appointments/appointment_integration";
                params = data;
                success_message = GlobalTranslations['APP_LABEL.INTEGRATIONS.APPOINTMENT.SUCCESS'];
                break;

            case globalConstants.PROFESSIONAL_INTEGRATION:
                url = "/professional/professional_integration";
                params = data;
                success_message = GlobalTranslations['APP_LABEL.INTEGRATIONS.PROFESSIONAL.SUCCESS'];
                break;

            case globalConstants.PROFESSIONAL_CALENDAR_INTEGRATION:
                url = "/configurations/calendar/professional_calendar_integration";
                params = data;
                success_message = GlobalTranslations['APP_LABEL.INTEGRATIONS.PROFESSIONAL_CALENDAR.SUCCESS'];
                break;

            case globalConstants.PROFESSIONAL_RESERVATION_INTEGRATION:
                url = "/configurations/calendar/professional_reservation_integration";
                params = data;
                success_message = GlobalTranslations['APP_LABEL.INTEGRATIONS.PROFESSIONAL_CALENDAR.SUCCESS'];
                break;

            case globalConstants.PROFESSIONAL_VACATIONS_INTEGRATION:
                url = "/configurations/calendar/professional_vacations_integration";
                params = data;
                success_message = GlobalTranslations['APP_LABEL.INTEGRATIONS.PROFESSIONAL_CALENDAR_VACATIONS.SUCCESS'];
                break;
        }

        $.ajax({
            url: url,
            dataType: "json",
            type: 'POST',
            data: params,

            success: function (data,st, xhr) {

                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.flg_integrated == true){
                    if (data.data == null) {
                        bootbox.alert(error_message);
                    }
                    else if (data.data.resultStatus == 1){
                        // bootbox.alert(success_message);
                        Hades.hideLoading();
                    }
                    else
                    {
                        bootbox.alert(error_message);
                    }
                }

            },
            error: function (data,st, xhr) {
                bootbox.alert(error_message);
                Hades.hideLoading();
            }
        });

    }
};